import classNames from 'classnames';

import CenteredContent from 'components/CenteredContent';

import type { BannerCenteredContentType } from './types';

import useStyles from './styles';

function BannerCenteredContent({
  isBackgroundAccented,
  templatesDimensions,
  brandsDimensions,
  autoDimensions,
  carouselLayout,
  isSecondary,
  narrow,
  className,
  isPrimary,
  children,
}: BannerCenteredContentType) {
  const styles = useStyles({ autoDimensions, isBackgroundAccented });

  const rootClassNames = classNames(styles.root, className, {
    'auto-dimensions': autoDimensions,
    templates: templatesDimensions,
    brands: brandsDimensions,
    carousel: carouselLayout,
    secondary: isSecondary,
    primary: isPrimary,
  });

  return (
    <div className={rootClassNames} data-testid="banner-centered-content">
      {(autoDimensions ||
        isPrimary ||
        isSecondary ||
        carouselLayout ||
        templatesDimensions ||
        brandsDimensions) && <CenteredContent appLayout={narrow}>{children}</CenteredContent>}
      {!(
        autoDimensions ||
        isPrimary ||
        isSecondary ||
        carouselLayout ||
        templatesDimensions ||
        brandsDimensions
      ) && children}
    </div>
  );
}

export default BannerCenteredContent;
